<template>
<div class="dx-card preview-cell-container" :data-cellref="cellData.id">
	<div class="cell-content" v-if="!props.usePlaceholder">
		<ux-list v-if="props.type == 'list'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-datagrid v-if="props.type == 'datagrid'" :settings="props.settings" :context="props.page" :preview="true" @actionEditorAdd="$emit('actionEditorAdd', $event)" @actionEditorEdit="$emit('actionEditorEdit', $event)" />
		<ux-itemview v-if="props.type == 'itemview'" :context="props.page" :preview="true" />
		<ux-chart v-if="props.type == 'chart'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-drive v-if="props.type == 'drive'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-calendar v-if="props.type == 'calendar'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-imageview v-if="props.type == 'imageview'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-gallery v-if="props.type == 'gallery'" :settings="props.settings" :context="props.page" :preview="true" />
		<ux-html v-if="props.type == 'html'" :settings="props.settings" :context="props.page" :preview="true" />
	</div>
	<div class="cell-content" v-else>
		<div style="background:#ccc;border:1px dashed #aaa;padding:5px;justify-content:center;">
			Cell being edited!
		</div>
	</div>
	
	<div class="overlay-buttons">
		<div class="top-buttons">
			<DxButton text="🡅 Row Above 🡅" stylingMode="text" type="default" @click="$emit('addColumnOrRow', 'row-above')" class="overlay-button" />
		</div>
		<div class="edit-button">
			<DxButton text="Edit" icon="preferences" stylingMode="text" type="default" @click="$emit('editCell')" class="overlay-button" />
		</div>
		<div class="left-buttons">
			<DxButton text="🡇 Col Left 🡇" stylingMode="text" type="default" @click="$emit('addColumnOrRow', 'col-left')" class="overlay-button column-button" />
		</div>
		<div class="right-buttons">
			<DxButton text="🡅 Col Right 🡅" stylingMode="text" type="default" @click="$emit('addColumnOrRow', 'col-right')" class="overlay-button column-button" />
		</div>
		<div class="bottom-buttons">
			<DxButton text="🡇 Row Below 🡇" stylingMode="text" type="default" @click="$emit('addColumnOrRow', 'row-below')" class="overlay-button" />
		</div>
	</div>
</div>
</template>

<style lang="scss">
.preview-cell-container {
	margin: 10px;
	padding: 10px;
	position: relative;
	
	.cell-content {
		width: 100%;
		height: calc(100% - 40px);
		min-height: 200px;
	}
	.overlay-buttons {
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;
		pointer-events: none;
		z-index: 10;
	}
	.overlay-button {
		pointer-events: auto;
		background: rgba(255, 255, 255, 0.9);
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 12px;
		padding: 4px 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		&:hover {
			background: rgba(255, 255, 255, 1);
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
		}
	}

	.top-buttons {
		position: absolute;
		top: 5px; left: 5px; right: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.edit-button {
		position: absolute;
		top: 5px; right: 5px;
		z-index: 11;
	}
	.left-buttons {
		position: absolute;
		left: 5px; top: 50%;
		transform: translateY(-50%);
	}
	.right-buttons {
		position: absolute;
		right: 5px; top: 50%;
		transform: translateY(-50%);
	}
	.bottom-buttons {
		position: absolute;
		bottom: 5px; left: 5px; right: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.column-button {
		writing-mode: vertical-rl;
		text-orientation: mixed;
		height: auto;
		white-space: pre-line;
	}
}
</style>

<script setup>
// This is a component used to render a single cell in the page layout - as a preview along with the edit buttons and row/cell actions.
// Because it instantiates ux-components without context, all changes should be locked out automatically.
// NB: using slots here to render our ux-* components doesn't seem to work with other DevExtreme components for some reason -- not sure why.
import DxButton from 'devextreme-vue/button';
import { defineProps } from 'vue';

import UxList from '../components/ux/ux-list';
import UxDatagrid from '../components/ux/ux-datagrid';
import UxItemview from '../components/ux/ux-itemview';
import UxChart from '../components/ux/ux-chart';
import UxDrive from '../components/ux/ux-drive';
import UxCalendar from '../components/ux/ux-calendar';
import UxImageview from '../components/ux/ux-imageview';
import UxGallery from '../components/ux/ux-gallery';
import UxHtml from '../components/ux/ux-html';

const props = defineProps([
	'type',
	'settings',
	'cellData',
	'usePlaceholder',
	'page',
]);

</script>
